import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormControl, FormGroup } from '@angular/forms';
import { FormValidatorService } from '../../../../shared/services/form-validator.service';
import { Validators } from '../../../../shared/validators';
import { CustomValidators } from '../../../../shared/custom-validators';
import { BaseForm } from '../../../../shared/product/baseForm';
import { GetBusinessByCodeService } from '../../services/get-business-by-code.service';
import { Subscription } from 'rxjs';
import Swal from 'sweetalert2';
import { ViewProductInfoHandlerService } from '../../services/view-product-info-handler.service';
import { ApplyPromoCodeService } from '../../../../shared/services/apply-promo-code.service';
import { GetCalculatesParamsService } from '../../services/get-calculates-params.service';
import { CreateCustomPaymentProductService } from '../../../../shared/services/create-custom-payment-product.service';
import { GetCustomPaymentAmounService } from '../../../../shared/services/get-custom-payment-amount.service';
import { ProductTypes } from '../../../../shared/product/productTypes';
import { GetCustomPaymentBuyerInfo } from 'src/app/dashboard/seller/my-account/services/getCustomPaymentBuyerInfo.service';
import { CustomPaymentBuyerInfoDataTransform } from 'src/app/dashboard/seller/my-account/components/custom-payment-buyer-ifno-setting/CustomPaymentBuyerInfoDataTransform.service';
import { TranslateService } from '@ngx-translate/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Component({
  selector: 'app-public-payment',
  templateUrl: './public-payment.component.html',
  styleUrls: [
    './public-payment.component.scss',
    '../buyer-info/components/buyer-payment-options/buyer-payment-options.component.scss',
  ],
})
export class PublicPaymentComponent extends BaseForm implements OnInit {
  businessData: any;
  formValidator = new FormValidatorService();
  customPaymentForm!: FormGroup;
  amount: number = 0;
  description: string = '';
  step: number = 1;
  verifySuccess: boolean = false;
  verifyError: boolean = false;
  prevCode: string = '';
  isConnected: boolean = false;
  notValid: boolean = false;
  buttonText :string = 'Select Payment Options';
  disableSection = false;
  customPaymentFields = {
    code: {
      fieldName: 'Receiver Reference',
      fieldNameAr: 'مرجع المستقبل',
      fieldType: 'Amount',
      validators: [
        {
          validatorFn: Validators.required,
          message: `${this.validationMsg.required}`,
          messageAr: `${this.validationMsgAr.required}`,
        },
        {
          validatorFn: CustomValidators.customPattern(/^\d{6}$/),
          message: 'Code must be 6 digits',
        },
        {
          validatorFn: CustomValidators.customPattern(
            /^(([0-9])+([.][0-9]*)?|[.][0-9]+)$/
          ),
          message: `${this.validationMsg.requiredNumber}`,
          messageAr: `${this.validationMsgAr.requiredNumber}`,
        },
        {
          validatorFn: Validators.minLength(6),
          message: `${this.validationMsg.minLength}6 digits`,
          messageAr: `${this.validationMsgAr.minLength}الـ 6 ارقام`,
        },
        {
          validatorFn: Validators.maxLength(6),
          message: `${this.validationMsg.maxLength}6 digits`,
          messageAr: `${this.validationMsgAr.maxLength}الـ 6 ارقام`,
        },
      ],
      defaultValue: '',
    },
    amount: {
      fieldName: 'Amount',
      fieldNameAr: 'المبلغ',
      fieldType: 'Amount',
      validators: [
        {
          validatorFn: Validators.required,
          message: `${this.validationMsg.required}`,
          messageAr: `${this.validationMsgAr.required}`,
        },
        {
          validatorFn: CustomValidators.customPattern(
            /^(([0-9])+([.][0-9]*)?|[.][0-9]+)$/
          ),
          message: `${this.validationMsg.requiredNumber}`,
          messageAr: `${this.validationMsgAr.requiredNumber}`,
        },
        {
          validatorFn: Validators.min(1),
          message: `${this.validationMsg.min}1`,
          messageAr: `${this.validationMsgAr.min}الـ1`,
        },
      ],
      defaultValue: 0,
    },
    amountCalculate: {
      fieldName: 'AmountCalculate',
      fieldNameAr: 'حساب المبلغ',
      fieldType: 'AmountCalculate',
      validators: [],
      defaultValue: 0,
    },
    description: {
      fieldName: 'Description',
      fieldNameAr: 'الوصف',
      fieldType: 'Description',
      defaultValue: '',
    },
  };
  promoDialogOpen: boolean = false;
  subTotal: number = 0;
  total: number = 0;
  taxes: number = 0;
  fees: number = 0;
  feesObjectArray: any[] = [];
  promoForm!: FormGroup;
  freeProduct: boolean = false;
  businessName: any;
  subscriptions: Subscription[] = [];
  promoCodeVisible: boolean = false;
  promoField: string = 'promo-code-field';
  qassatlyLimit: number = 0;
  selection: string = '';
  businessId: number;
  selectedCurrency = 'EGP';
  checked: boolean;
  isMobile: boolean = false;
  hideHeader: boolean = false;
  changePaymentOption: boolean = false;

  constructor(
    private getBusinessByCodeService: GetBusinessByCodeService,
    private router: Router,
    public vpihs: ViewProductInfoHandlerService,
    public applyCodeSv: ApplyPromoCodeService,
    public getCalculatesParamsService: GetCalculatesParamsService,
    private createCustomPaymentProductService: CreateCustomPaymentProductService,
    private getCustomPaymentAmounService: GetCustomPaymentAmounService,
    private getBusinessCustomPaymentExtraBuyerInfo: GetCustomPaymentBuyerInfo,
    private customPaymentDataTransform: CustomPaymentBuyerInfoDataTransform,
    private translate: TranslateService,
    private breakpointObserver: BreakpointObserver
  ) {
    super();
  }

  ngOnInit() {
    const whatsappBtn =  document.getElementById('whatsapp-chat-widget');
    if(whatsappBtn) whatsappBtn.style.display = 'block';
    this.breakpointObserver.observe([Breakpoints.Small, Breakpoints.Handset])
    .subscribe(result => {
      this.isMobile = result.matches;
    });

  this.router.events.subscribe(() => {
    if (this.router.url.includes('/buyerinfo')) {
      this.hideHeader = true;
      this.vpihs.viewInfoObject = {
        ...this.vpihs.viewInfoObject,
        extras: {
          isCustomPayment: true
        }
      }
    } else {
      this.hideHeader = false
      this.step = 1
      this.checked = false;
      this.selection =''
      this.vpihs.viewInfoObject = {
        ...this.vpihs.viewInfoObject,
        extras: {
          isCustomPayment: false
        }
      }
    }
  });

    this.customPaymentForm = this.formValidator.createForm(
      Object.values(this.customPaymentFields)
    );

    this.customPaymentForm
      .get('Receiver Reference')
      ?.valueChanges.subscribe(() => {
        this.verifySuccess = false;
        this.verifyError = false;
      });

    this.subTotal = 0;

    this.total = this.vpihs.total;
    this.taxes = this.vpihs.taxes;
    this.fees = this.vpihs.fees;
    this.feesObjectArray = this.vpihs.feesObjectArray;
    this.subscriptions.push(
      this.vpihs.feesObjectArrayEmitter.subscribe(
        (value: any) => {
          this.feesObjectArray = value;
        },
        (error: any) => {
          console.log(error);
        },
        () => {
          console.log('listened');
        }
      )
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subs) => subs.unsubscribe());
  }

  calculateAmount() {
    const value = this.customPaymentForm.value.Amount;
    this.customPaymentForm.controls['AmountCalculate'].setValue(+value);
    this.amount = this.customPaymentForm.value.Amount;
    this.description = this.customPaymentForm.value.Description;
    this.vpihs.subTotal = +this.amount;
    this.vpihs.quantity = 1;
    this.vpihs.viewInfoObject = {
      business: this.businessData,
      extras: {
        isCustomPayment: true,
      },
    };
    let heightbody = document.body.offsetHeight;
    if (heightbody > 2000) {
      setTimeout(() => {
        window.scroll(0, heightbody - 1000);
      }, 1000);
    }
  }

  onAmountChange(value: any) {
    this.vpihs.total = value;
  }

  convertPaymentControl(name: string): FormControl {
    return this.customPaymentForm.controls[name] as FormControl;
  }

  onCodeBlur() {
    if (
      this.customPaymentForm.controls['Receiver Reference'].valid &&
      this.prevCode != this.customPaymentForm.value['Receiver Reference']
    ) {
      this.prevCode = this.customPaymentForm.value['Receiver Reference'];
      this.isConnected = false;
      this.verifyCode();
    }
  }

  async verifyCode() {
    try {
      const code = this.customPaymentForm.value['Receiver Reference'];

      this.getBusinessByCodeService.setParams({
        code: code,
      });

      this.businessData = await this.getBusinessByCodeService.make();

      this.businessId = this.businessData.id;
      this.vpihs.BusinessId = this.businessId;

      this.isConnected = true;
      this.verifySuccess = true;
      this.verifyError = false;

    } catch (err) {
      this.prevCode = '';
      this.notValid = true;
      this.isConnected = false;
      this.verifySuccess = false;
      this.verifyError = true;
    }
  }

  async submit() {
    this.changePaymentOption = true;
    this.step = 3;
    this.hideHeader = true;
    if (this.vpihs.quantity < 1) return;

    if (
      this.vpihs.subTotal > this.qassatlyLimit &&
      this.vpihs.paymentOptionObject.selection == 'Qassatly'
    ) {
      return this.qassatlyLimitError();
    }

    if (this.freeProduct || (this.selection && this.vpihs.subTotal !== 0)) {
      this.vpihs.Dividing = this.getExchangeRate();
      this.vpihs.setPaymentOptionObject({
        selection: this.selection,
      });
      let productValues: any = {
        name: this.description,
        type: ProductTypes.customPayment,
        isCustomPayment: true,
        businessId: this.businessData.id,
        extraInfo: {
          amount: this.currencyAmount(this.vpihs.subTotal),
          description: this.description,
        },
      };

      let defaultBuyerInfos = [
        {
          id: '',
          fieldName: 'Name',
          fieldRequired: true,
          fieldType: '1',
          value: [],
        },
        {
          id: '',
          fieldName: 'Email',
          fieldRequired: true,
          fieldType: '1',
          value: [],
        },
        {
          id: '',
          fieldName: 'Phone',
          fieldRequired: true,
          fieldType: '1',
          value: [],
        },
      ];
      const businessId = this.businessData.id;
      this.getBusinessCustomPaymentExtraBuyerInfo.setParams({ businessId });
      const res = await this.getBusinessCustomPaymentExtraBuyerInfo.make();
      const customBuyerInfoFields = res.found
        ? this.customPaymentDataTransform.transformIncomingValues(
            res.result.BuyerInfoFields
          )
        : [];
      productValues['buyerInfos'] = [
        ...customBuyerInfoFields,
        ...defaultBuyerInfos,
      ];
      this.createCustomPaymentProductService.setParams(productValues);
      try {
        let result = await this.createCustomPaymentProductService.make();

        if (result) {
          this.vpihs.setProductId(result.id);
          //we need businessdata in product and remove payment option selection
          this.vpihs.setViewInfoObject({
            ...this.vpihs.viewInfoObject,
            product: {
              ...result,
              Business: {
                ...this.businessData,
              },
              paymentOptions: '',
            },
          });
        }
        this.router.navigate([`pay/buyerinfo`]);
      } catch (err) {
        this.step--;
        return this.customPaymentError();
      }
    } else {
      console.log('does not have value');
    }
    this.scrollToY();
  }
  scrollToY() {
    let heightbody = document.body.offsetHeight;
    setTimeout(() => {
      window.scroll(0, heightbody - 300);
    }, 1000);
  }
  async radioChange() {
    this.customPaymentForm.get('Receiver Reference')?.setValue(this.prevCode);
    this.step = 2;
    this.disableSection =true
    this.selection = this.vpihs.paymentOptionObject.selection;
    this.calculateAmount();
    this.calculatePayment();
    this.getCalculatesParamsService.setPaymentOptions(this.selection);
    if (this.changePaymentOption){
      this.submit();
    }
    this.buttonText = this.selection
  }

  isContinueDisabled() {
    return (
      (this.vpihs.subTotal <= 0 && this.selection) ||
      !this.customPaymentForm.valid ||
      !this.amount ||
      !this.selection
    );
  }

  async calculatePayment() {
    this.getCustomPaymentAmounService.setParams({
      amount: this.currencyAmount(this.vpihs.subTotal) || 0,
      businessId: this.businessData.id || 0,
      paymentOption: this.selection || null,
    });
    let calculateObject = await this.getCustomPaymentAmounService.make();
    this.qassatlyLimit = +calculateObject.limit;
    let feesArray = calculateObject.purchaseFees
      ? [calculateObject.purchaseFees]
      : [];
    this.vpihs.merchantFees = calculateObject.merchantFees;
    this.vpihs.setFeesObjectArray(feesArray);
    this.vpihs.fees = this.currencyEGPAmount(calculateObject.fees);
    this.fees = this.vpihs.fees;
    this.vpihs.vat = calculateObject.vat;
    if (this.vpihs.subTotal) {
      this.vpihs.total = this.currencyEGPAmount(calculateObject.totalAmount);
      this.subTotal = this.vpihs.subTotal;
      this.total = this.vpihs.total;
    }
  }

  onCurrencyChange(currency: string): void {
    this.selectedCurrency = currency;
    this.vpihs.currency = this.selectedCurrency;
  }

  getExchangeRate(): number {
    const currencyExchangeName = this.selectedCurrency + 'EGP';
    const exchangeRate = this.vpihs.exchangeRates.find(
      (er) => er['name'] === currencyExchangeName
    );
    return exchangeRate ? exchangeRate['rate'] : 1;
  }

  currencyAmount(value: number): number {
    const rate = this.getExchangeRate();
    return +(value * rate).toFixed(2);
  }

  currencyEGPAmount(value: number): number {
    const rate = this.getExchangeRate();
    return +(value / rate).toFixed(2);
  }

  qassatlyLimitError() {
    Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: "The amount of this purchase is more than the allowed lending limit for the business you're buying from. Please contact the seller.",
    });
  }

  customPaymentError() {
    Swal.fire({
      icon: 'error',
      title: this.translate.instant('FORM_TEMPLATE.ERROR_TITLE'),
      text: this.translate.instant('ERROR.CUSTOM_PAYEMNT_ERROR'),
    });
  }

  previousStep(step: number) {
    this.disableSection =false;
    if (step == 2) {
      this.step = step - 1;
    }
    if (step == 3) {
      this.step = step - 2;
    }
    this.router.navigate([`/pay`]);
    this.vpihs.viewInfoObject = {
      business: this.businessData,
      extras: {
        isCustomPayment: false
      }
    }
    let heightbody = document.body.offsetHeight;
    if (heightbody > 2000) {
      window.scrollTo(0, heightbody - 2500);
    }
    this.checked = false;
    this.fees = 0.0;
    this.subTotal = 0.0;
    this.total = 0.0;
    this.vpihs.fees = 0;
    this.vpihs.subTotal = 0;
    this.vpihs.total = 0;
  }

  isNumber(value) {
    return /^\d+\.\d+$/.test(value) || /^\d+$/.test(value);
  }

  nextStep() {
    if (this.step < 3) {
      this.step++;
      this.checked = false;
      this.vpihs.viewInfoObject = {
        ...this.vpihs.viewInfoObject,
        extras: {
          isCustomPayment: false
        }
      }
    }
  }
  enableSection(){
    this.disableSection =false;
    this.router.navigate([`/pay`]);
    this.vpihs.viewInfoObject = {
      business: this.businessData,
      extras: {
        isCustomPayment: false
      }
    }
    let heightbody = document.body.offsetHeight;
    if (heightbody > 2000) {
      window.scrollTo(0, heightbody - 2500);
    }
    this.buttonText ='Select Payment Options'
    this.vpihs.paymentOptionObject.selection =''
    this.checked = false;
    this.fees = 0.0;
    this.subTotal = 0.0;
    this.total = 0.0;
    this.vpihs.fees = 0;
    this.vpihs.subTotal = 0;
    this.vpihs.total = 0;
  }
}
